module.exports = __webpack_public_path__ + "static/media/icon_contact.7bb49908.svg";